import api from "@/apis/ProcessAPI";
import Crud from "./crud-base";
var crud = new Crud("process", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "ProcessID",
      code: "ProcessDate",
      name: "ProcessDate",
    },
  },
};
const getters = {
  ...crud.getters,
};
const mutations = {
  ...crud.mutations,
};

const actions = {
  ...crud.actions,
  /**
   * Xóa
   */
  async multiAllocationEmployee(context, payload) {
    return await api.multiAllocationEmployee(payload);
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
